export enum OpenAdminWidgetEventNames {
  END_FLOW_BASE_SCREEN = "end_flow_base_screen",
}
